import React, { Component } from 'react';
import Chart from "react-apexcharts";

class StorageChart extends Component {

    constructor(props) {

        super(props);

        this.state = {
            options: {
                chart: {
                    height: 250,
                    type: 'radialBar',
                },
                colors: ['#1A82CC'],
                plotOptions: {
                    radialBar: {
                        hollow: {
                            size: '70%',
                        }
                    },
                },
                labels: ['Storage'],
            },
            series: [props.storagePercentage],
        };
    }
    
    render() {
        return (
            <div>
                <Chart
                    options={this.state.options}
                    series={this.state.series}
                    type="radialBar"
                    height="200px"
                />
            </div>
        );
    }
}

export default StorageChart;
